// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.patient.PatientSearchStringRequest */
/* istanbul ignore next */
@GandalfModel
export class PatientSearchStringRequest extends GandalfModelBase {

	@GandalfLabel('Search Parameters')
	@GandalfValidator({ notNull: { message: 'Search Parameters is required' } })
	@GandalfValidator({ sizeString: { min: 0, max: 255, message: 'Search Parameters cannot be longer than 255 characters' } })
	@GandalfProperty({ designType: String, isRequired: true })
	searchString!: string;

}
